/**
 * @Description <br/>
 * Border: _Define a curvatura dos cantos de um elemento._
 * 
 * @Available <br/>
 * _xs: 0.125rem | sm: 0.25rem | md: 0.5rem | lg: 1rem._
 * 
 * @Example <br/>
 * _Use borders.sm para border-radius = 4px._
 */

export const borders = {
  xs: "0.125rem",     // ${borders.xs}
  sm: "0.25rem",      // ${borders.sm}
  md: "0.5rem",       // ${borders.md}
  ml: "0.625rem",     // ${borders.ml}
  lg: "1rem",         // ${borders.lg}
  xl: "1.5rem"        // ${borders.xl}
}